module.exports = __webpack_public_path__ + "img/tractorUnitRearLeft.edf791d0.svg";